import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=1e10ccdc&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"
import style0 from "./index1.vue?vue&type=style&index=0&id=1e10ccdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e10ccdc",
  null
  
)

export default component.exports